import React from "react";
import type { BoxProps } from "@/ui/atoms/Box";
import Box from "@/ui/atoms/Box";

export type LayoutFillParentWithFooterProps = BoxProps & {
    MainContentProps?: BoxProps;
    FooterProps?: BoxProps;
    footerContent?: React.ReactNode;
};

export const testIds = {
    main: "LayoutFillParentWithFooter",
    content: "LayoutFillParentWithFooter-content",
    footer: "LayoutFillParentWithFooter-footer",
};

const LayoutFillParentWithFooter = (props: LayoutFillParentWithFooterProps) => {
    const {
        sx,
        children,
        footerContent,
        MainContentProps,
        FooterProps,
        ...otherProps
    } = props;

    return (
        <Box
            data-testid={testIds.main}
            className={testIds.main}
            sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                backgroundColor: "var(--proda-white)",
                boxSizing: "border-box",
                ...sx,
            }}
            {...otherProps}
        >
            <Box
                {...MainContentProps}
                data-testid={testIds.content}
                sx={{
                    flex: 1,
                    overflow: "auto",
                    backgroundColor: "var(--proda-white)",
                    boxSizing: "border-box",
                    ...MainContentProps?.sx,
                }}
            >
                {children}
            </Box>
            <Box
                {...FooterProps}
                data-testid={testIds.footer}
                sx={{
                    height: "113px",
                    borderTop: "2px solid var(--proda-neon-blue-10)",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    flexShrink: 0,
                    backgroundColor: "var(--proda-white)",
                    boxSizing: "border-box",
                    ...FooterProps?.sx,
                }}
            >
                {footerContent}
            </Box>
        </Box>
    );
};

export default LayoutFillParentWithFooter;
